export type OrderCategory = "limit" | "tracking";

export const selectOrderCategory = <
  T extends {
    type: string;
    remaining: bigint;
    filled: bigint;
  },
>(
  orders: readonly T[],
  category: OrderCategory
) => {
  const all = orders.filter((order) =>
    category === "limit" ? order.type === "fixed" : order.type === "oracle"
  );
  return {
    all,
    open: all.filter((order) => order.remaining > 0n),
    filled: all.filter((order) => order.filled > 0n),
    total: all.length,
  };
};
